import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getCdtWithSpecialties } from 'api/CdtCodes';
import { getCptCodes, getWithSpecialties } from 'api/CptCodes';

export const useCPTCodes = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();
  return useQuery(['cptCodes', ...dependencies], () => getCptCodes(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};

export const usePracticeCPTCodes = ({
  params = {},
  options = {},
  dependencies = [],
  kind
} = {}) => {
  const navigate = useNavigate();
  const isDental = kind === 'dental';
  const fetchWithSpecialties = isDental ? getCdtWithSpecialties : getWithSpecialties;
  return useQuery(
    ['practiceCptCodes', isDental ? 'cdt' : 'cpt', ...dependencies],
    () => fetchWithSpecialties(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
